import WebViewer from './coi/WebViewer';
window.Symbol = require('es6-symbol/polyfill.js');

// Main
$(function() {

	var args = window["startupArgs"];
	if (args == null){
		args = [];

		var startIndex = window.location.href.indexOf('?') + 1;
		var stopIndex = window.location.href.indexOf('#');

		if (stopIndex == -1)
			stopIndex = window.location.href.length;

	    var queryString = window.location.href.slice(startIndex, stopIndex);
	    var pairs = queryString.split('&');
	    for(var i = 0; i < pairs.length; i++) {
	        let res = pairs[i].split('=');
	        let key = res[0];
	        let value = res[1];

	        args[key] = value;
	    }
	}

    // ==========

    var viewer = new WebViewer(args);
    viewer.run();

});